<!--
アンケート回答完了
URL：answer/completed
-->

<template>
  <div>
    <v-container style="max-width: 800px"> 
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-subtitle">
          アンケートの回答を受け付けました
        </v-card-title>
      </v-card>
    </v-container>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped>
.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}

.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}

.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}
</style>
